export enum PaymentType {
  PACA = "PACA", // 신용카드
  PABK = "PABK", // 계좌이체
  PAVC = "PAVC", // 가상계좌
  PAPT = "PAPT", // 포인트
  PAMC = "PAMC", // 휴대폰
  PATK = "PATK", // 상품권
  PAKM = "PAKM", // 카카오머니
  PANP = "PANP", // 네이버페이 포인트
  PACP = "PACP", // 페이코 포인트
  PALT = "PALT", // 후불결제
}

export const paymentTypeDisplayNames = {
  [PaymentType.PACA]: "신용카드",
  [PaymentType.PABK]: "계좌이체",
  [PaymentType.PAVC]: "가상계좌",
  [PaymentType.PAPT]: "포인트",
  [PaymentType.PAMC]: "휴대폰",
  [PaymentType.PATK]: "상품권",
  [PaymentType.PAKM]: "카카오머니",
  [PaymentType.PANP]: "네이버페이 포인트",
  [PaymentType.PACP]: "페이코 포인트",
  [PaymentType.PALT]: "후불결제",
};
